module.exports = __webpack_public_path__ + "assets/img/b19a007b3671bf2142c75907350262b2.svg";